import { combineReducers } from 'redux';

import animes from './animes';

export default combineReducers({
  animes,
});
